import React from 'react';
import calendar from './../../../assets/img/brand/pzu/calendar.png';
import info from './../../../assets/img/brand/pzu/info.png';
import exclamationMark from './../../../assets/img/brand/pzu/exclamationMark.png';

const ZasadyPrzystepowania = (props) => {
  return (
    <React.Fragment>
      <h3 className="page-header firstColor">
        Jak przystąpić do ubezpieczenia zdrowotnego
      </h3>
      <div className="secondColor">
        <p>
          Każdy pracownik TVP ma możliwość skorzystania z opieki medycznej
          finansowanej przez pracodawcę.
        </p>
        <p>
          Aby przystąpić do ubezpieczenia zarejestruj się i{' '}
          <b>wypełnij formularz online dla siebie i swoich najbliższych.</b>
        </p>

        {/* <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 text-right">
              <img src={exclamationMark} alt="exclamation" />
            </div>
            <div className="col-sm">
              <b>Uwaga!</b> Jeżeli aktualnie jesteś objęty ubezpieczeniem Opieka
              Medyczna w TUW PZUW wypełnij na nowo formularz przystąpienia.
              Jeśli nie wypełnisz formularza oraz nie dostarczysz zgody na
              potrącenie składki z wynagrodzenia do <b>15 grudnia 2025</b> roku,
              ochrona ubezpieczeniowa Twoja i członków Twojej rodziny{' '}
              <b>zakończy się z dniem 31 grudnia 2025 roku.</b>
            </div>
          </div>
        </div> */}

        <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center">
              {/* <img src={calendar} alt="calendar" /> */}
            </div>
            <div className="col-sm">
              Wydrukuj i <b>podpisz dokumenty</b> wraz ze{' '}
              <b>wszystkimi zgłoszonymi członkami rodziny</b> (w przypadku
              niepełnoletniego dziecka deklarację podpisuje opiekun prawny).
            </div>
          </div>

          <div className="row">
            <div className="col-sm-1 d-flex align-items-center"></div>
            <div className="col-sm pl-0">
              <ul className="listArrowRight">
                <li className="mt-4">
                  <b>
                    Oryginał zgody na potrącenia składki z wynagrodzenia dla TVP
                  </b>{' '}
                  prześlij za pośrednictwem sekretariatów jednostek
                  organizacyjnych do <b>BZKL.</b>
                </li>
                <li className="mt-4">
                  <b>Deklarację</b> przystąpienia do ubezpieczenia dla siebie i
                  członków rodziny{' '}
                  <b>prześlij w formie skanu lub zdjęcia na adres mailowy:</b>{' '}
                  <a href="mailto:deklaracje@uspartner.pl">
                    <b className="firstColor">deklaracje@uspartner.pl</b>
                  </a>{' '}
                  lub w oryginale listownie na adres: Unique Service Partner sp.
                  z o.o., ul. Obrzeżna 7, 02-691 Warszawa.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={calendar} alt="calendar" />
            </div>
            <div className="col-sm">
              Aby zostać objętym ubezpieczeniem zdrowotnym od{' '}
              <b>1 dnia miesiąca</b> należy do <b>10 dnia poprzedniego</b>{' '}
              miesiąca wypełnić formularz online i przekazać podpisane
              dokumenty: wniosek oraz deklarację na wyżej wskazane adresy. Jeśli
              wypełnisz formularz do <b>10 stycznia</b> opieka medyczna
              rozpocznie się od <b>1 lutego</b>, jeśli wypełnisz formularz
              pomiędzy 11 stycznia a 10 lutego opieka medyczna rozpocznie się{' '}
              <b>1 marca.</b>
            </div>
          </div>
        </div>
        <br />
        <span>
          Możesz również objąć ubezpieczeniem członków swojej rodziny,
          wybierając odpowiedni pakiet:
        </span>
        <ul className="mt-3">
          <li>
            Pakiet Partnerski – dla pracownika i jednego członka rodziny
            (małżonka/partnera życiowego albo dziecka*)
          </li>
          <li>
            Pakiet Rodzinny – dla pracownika i dwóch lub więcej członków rodziny
            (małżonka/partnera życiowego i/lub dzieci bez względu na ich
            liczbę*),
            <br />
            <small>
              *Dziecko własne lub przysposobione, pozostające na utrzymaniu
              pracownika TVP, do ukończenia 26 roku życia.
            </small>
          </li>
          <li>
            Dorosłe dziecko – dla dorosłego dziecka pracownika, które ukończyło
            26 r.ż.
          </li>
          <li>
            Seniora – dla rodziców i teściów pracowników TVP, którzy nie
            ukończyli 80 r.ż
          </li>
        </ul>

        <span className="mt-4">
          Deklarację przystąpienia do ubezpieczenia dla dorosłego dziecka lub
          seniora należy złożyć za pośrednictwem formularza online, wybierając
          odpowiednią sekcję: <b>„Senior"</b> lub <b>„Dorosłe Dziecko"</b>. W
          tych sekcjach znajdziesz również informacje dotyczące zasad płatności
          za pakiety oraz terminów składania deklaracji
        </span>

        <div className="container mt-4">
          <div className="row">
            <div className="col-sm-1 text-right">
              <img src={info} alt="info" />
            </div>
            <div className="col-sm">
              <b>Pamiętaj:</b> aby zgłosić do ubezpieczenia członków rodziny w
              tym seniora lub dorosłe dziecko musisz mieć aktywny pakiet opieki
              medycznej.
            </div>
          </div>
        </div>
        <br />
        <br />
        <span>
          <b className="firstColor">
            Możesz dokonać zmiany pakietu lub zakresu ubezpieczenia wypełniając
            nową deklarację przystąpienia
          </b>
        </span>
        <ul>
          <li>
            zmiana pakietu/zakresu z <b>„niższego na wyższy"</b> (np. z
            indywidualnego na pakiet partnerski lub rodzinny lub z zakresu
            Komfort Plus na Optimum) możliwa jest w <b>dowolnym momencie</b> z
            datą obowiązywania od 1 dnia kolejnego miesiąca.
          </li>
          <li>
            zmiana pakietu/zakresu z <b>„wyższego na niższy"</b> (np. zmiana z
            zakresu Optimum na Komfort Plus lub pakietu partnerskiego na
            indywidualny) możliwa jest w rocznicę umowy (tj. 1 stycznia 2027
            roku).
          </li>
        </ul>
        <span>
          Zmiany wymagają złożenia nowej deklaracji do 10. dnia miesiąca
          poprzedzającego ich wejście w życie. Po złożeniu nowej deklaracji
          pamiętaj o dostarczeniu oryginału zgody na potrącenie składki z
          wynagrodzenia do TVP i przesłaniu skanu deklaracji na adres{' '}
          <a href="mailto:deklaracje@uspartner.pl">
            <b className="firstColor">deklaracje@uspartner.pl</b>
          </a>
        </span>
        <br />
        <br />
        <b className="firstColor">Rezygnacja z ubezpieczenia</b>
        <br />
        <span>
          Pracownik lub członek jego rodziny ma prawo w każdej chwili
          zrezygnować z ubezpieczenia, bez konieczności podawania przyczyny.
          Deklaracje rezygnacji złożone do <b>10. dnia miesiąca</b> skutkują
          zakończeniem ochrony z <b>ostatnim dniem tego miesiąca</b>.
        </span>
        <br />
        <br />
        <span>
          <b>Ponowne przystąpienie do ubezpieczenia</b> możliwe jest wyłącznie w
          rocznicę umowy, tj. <b>01.01.2027 r.</b>
        </span>
        <br />
        <br />
        <span>
          Aby zrezygnować z ubezpieczenia, należy zalogować się na swoje konto i
          w sekcji <b>Moje wnioski</b> zaznaczyć w aktywnym wniosku opcję
          <b> Zrezygnuj.</b>
        </span>
      </div>
    </React.Fragment>
  );
};

export default ZasadyPrzystepowania;
